import { render, staticRenderFns } from "./new-general-ticket.vue?vue&type=template&id=9decd090&scoped=true&"
import script from "./new-general-ticket.vue?vue&type=script&lang=js&"
export * from "./new-general-ticket.vue?vue&type=script&lang=js&"
import style0 from "./new-general-ticket.vue?vue&type=style&index=0&id=9decd090&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9decd090",
  null
  
)

export default component.exports